import LaunchIcon from "@mui/icons-material/Launch";
import { Link } from "@mui/material";

interface Props {
  href: string;
  children: React.ReactNode;
  onClick?: VoidFunction;
}

export function NewTabLink(props: Props) {
  const { href, children, onClick } = props;
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        textDecoration: "underline",
      }}
    >
      {children}
      <LaunchIcon fontSize="small" />
    </Link>
  );
}
